import wkx from 'wkx';

export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('en-GB');
};

export const formatNumber = (
  num: number,
  maximumFractionDigits: number
): string => {
  return Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits,
  }).format(num);
};

export const formatAreaKm2 = (area: number) => {
  return (area / 1000000).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatArea = (area: number) => {
  // If area is greater than or equal to 1,000,000, convert to km², otherwise keep as m²
  if (area >= 1000000) {
    return (
      <>
        {formatAreaKm2(area)} <span className="text-neutral-30">km²</span>
      </>
    );
  } else {
    return (
      <>
        {area.toLocaleString()} <span className="text-neutral-80">m²</span>
      </>
    );
  }
};

export const ewktToEwkbHex = (ewkt: string): string => {
  const geometry = wkx.Geometry.parse(ewkt);
  const ewkb = geometry.toEwkb();
  return ewkb.toString('hex');
};

export const ewkbHexToGeoJSON = (ewkbHex: string): GeoJSON.Geometry | null => {
  try {
    // Convert EWKB Hex to WKB
    const wkbBuffer = Buffer.from(ewkbHex, 'hex');

    // Parse WKB using wkx
    const geometry = wkx.Geometry.parse(wkbBuffer);

    // Convert to GeoJSON and ensure it's a valid GeoJSON Geometry type
    const geoJSON = geometry.toGeoJSON() as GeoJSON.Geometry;

    return geoJSON;
  } catch (error) {
    return null;
  }
};

export const geoJSONToEwkbHex = (
  geoJSON: GeoJSON.Geometry | undefined
): string | undefined => {
  if (!geoJSON) return;
  const geometry = wkx.Geometry.parseGeoJSON(geoJSON);
  const ewkb = geometry.toEwkb();
  return ewkb.toString('hex');
};

const toSnakeCase = (str: string) =>
  str.replace(/([A-Z])/g, '_$1').toLowerCase();

export const convertKeysToSnakeCase = (obj: Record<string, any>) =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [toSnakeCase(key), value])
  );
